import React from 'react';

const Join = () => {
  return (
    <div className="App">
      <header className="App-header">
        <p>Welcome to Muscletease.net, we will be moving from muscletease.com over here.</p>
        <p>You can join temporarily by emailing your desired username and password to muscletease@gmail.com and <b>send a paypal payment of $14.99 to johntherevelator6969@gmail.com</b></p>
        <p>If you are buying a VOD, please also indicate which one and send amount as well as username and password.</p>
        <p>You can also subscribe below temporarily too but please email muscletease@gmail.com your username and password:</p>
        <div className="iframe-container">
          <iframe src={`${process.env.PUBLIC_URL}/join.html`} title="Join" style={{ width: '100vw', height: '100vh', border: 'none' }}></iframe>
        </div>
      </header>
    </div>
  );
};

export default Join;
